module.exports = __webpack_public_path__ + "img/mx.3aa223c8.svg";